import React, { useState, useEffect, useCallback } from "react";

// components
import Header from "./Header";
import Slider from "./Slider/Slider";

const MobileContent = ({
  events,
  selected,
  isOpen,
  handleClose,
  handleDirection,
}) => {
  const [list, setList] = useState([]);
  const [isGrow, setIsGrow] = useState(false);

  const handleList = useCallback(() => {
    if (events && selected) {
      let filter = events.filter((item) => item.EventId !== selected.EventId);
      let newList = [selected, ...filter];

      setList(newList);
    }
  }, [events, selected]);

  useEffect(() => {
    handleList();
  }, [handleList]);

  const toggle = () => setIsGrow(!isGrow);

  return (
    <>
      <Header isOpen={isOpen} />
      <Slider
        isOpen={isOpen}
        events={list}
        isGrow={isGrow}
        toggle={toggle}
        handleDirection={handleDirection}
        handleClose={handleClose}
      />
    </>
  );
};

export default MobileContent;
